var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusUpgraded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    id: "3o2vvoe3qa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#3o2vvoe3qa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0v24h24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5c-5.239 0-9.5 4.261-9.5 9.5s4.261 9.5 9.5 9.5 9.5-4.261 9.5-9.5-4.261-9.5-9.5-9.5zm5.14 9.17-1.848 1.893.439 2.685a1.017 1.017 0 0 1-1.497 1.053L12 16.067l-2.234 1.235a1.016 1.016 0 0 1-1.498-1.054l.438-2.685-1.845-1.893a1.017 1.017 0 0 1 .575-1.717l2.512-.384 1.132-2.411c.334-.716 1.508-.716 1.841 0l1.132 2.411 2.512.384a1.015 1.015 0 0 1 .574 1.717z",
    fillRule: "nonzero",
    fill: "#02607F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusUpgraded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-status-upgraded.46447b02c0a5d5ac84c0072941108868.svg";